import { Loader2 } from 'lucide-react';
import React from 'react';
import MyPhoneInput from './myPhoneInput';

interface LoadingState {
  phone: boolean;
  blueNumber: boolean;
}

interface ErrorState {
  phone: string;
  blueNumber: string;
}

interface PersonalInformationProps {
  form: {
    blueNumberId: string;
    countryCode: string;
    phoneNumber: string;
    roleId: number;
  };
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleMobileChange: (value: string | undefined) => void;
  loadingStates: LoadingState;
  errorStates: ErrorState;
  isEditMode: boolean;
}

const PersonalInformation: React.FC<PersonalInformationProps> = ({
  form,
  handleChange,
  handleMobileChange,
  loadingStates,
  errorStates,
  isEditMode,
}) => {
  const handleKeyDown = async (
    e: React.KeyboardEvent<HTMLInputElement>,
    field: 'phone' | 'blueNumber',
  ) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const input = e.currentTarget;
    }
  };

  return (
    <div className="rounded-2xl mx-auto text-[#621C43]">
      <div className="border-b border-b-[#621C43] px-6 py-5">
        <h2 className="font-Lato text-[28px] font-bold">Personal Information</h2>
        <p className="font-Lato text-[20px] font-Medium">
          {!isEditMode
            ? 'Enter the basic details for the new admin user'
            : 'Update the basic details for the admin user'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-1 gap-6 p-6">
        {/* Phone Number Field */}
        <div>
          <label className="block font-Lato text-[15px] font-medium mb-1">
            Mobile Number <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <MyPhoneInput
              value={form.phoneNumber}
              onChange={handleMobileChange}
              country={form.countryCode}
              disabled={loadingStates.phone}
              error={!!errorStates.phone}
            />
            {loadingStates.phone && (
              <div className="absolute right-3 top-1/2 -translate-y-1/2">
                <Loader2 className="w-4 h-4 animate-spin text-[#621C43]" />
              </div>
            )}
          </div>
          {errorStates.phone && <p className="text-red-500 text-xs mt-1">{errorStates.phone}</p>}
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;
